/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ server: NonNullable<unknown> }} Chat_Mcp_Tool_ServerInputs */



/**
* | output |
* | --- |
* | "via {server}" |
*
* @param {Chat_Mcp_Tool_ServerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_mcp_tool_server = /** @type {((inputs: Chat_Mcp_Tool_ServerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Mcp_Tool_ServerInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`über ${i?.server}`)
	return /** @type {LocalizedString} */ (`via ${i?.server}`)
});